import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Footer from "@components/Homepage/Footer";
import PublicPage from "@components/PublicPage";
import DefaultMetadata from "@components/DefaultMetadata";


const useStyles = makeStyles((theme) => ({
  box: {
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "75vh",
  },
}));


function AboutContainer() {
  const classes = useStyles();
  return (
    <PublicPage>
      <DefaultMetadata title="EV Loader | Σχετικά" />
      <CssBaseline />
      <Container maxWidth="md">
        <Box ml={7.5} mr={7.5} className={classes.box}>
          <About />
        </Box>
      </Container>
      <Footer />
    </PublicPage>
  );
}

function About() {
  return (
    <div className="content">
      <Typography component="h1" variant="h2" color="primary" style={{ textAlign: "center" }}>
        About
      </Typography>

      <Typography variant="body1" style={{ textAlign: "left" }}>
        Η εταιρία EV Loader αναπτύσσει το πρώτο ανοιχτό προς όλους δίκτυο
        φορτιστών στην Ελλάδα και την Νοτιανατολική Ευρώπη. Παρέχει λογισμικό
        διαχείρισης σταθμών φόρτισης σε επιχειρήσεις όπως ξενοδοχεία και
        καταστήματα που ήδη διαθέτουν σταθμό φόρτισης στο χώρο τους και
        προβάλλει το σημείο τους μέσω του χάρτη της εφαρμογής EV Loader αλλά και
        μέσω άλλων εφαρμογών. Στο δίκτυο EV Loader ανήκουν φορτιστές σε
        ξενοδοχεία όπως το Crowne Plaza, το Holiday Inn στην Αττική και boutique
        ξενοδοχεία από ομίλους όπως το Aria Hotels σε Ιωάννινα, Κεφαλονιά και
        Μάνη. Τα μέλη του δικτύου EV Loader αποκτούν άμεσα έσοδα από τις
        φορτίσεις επισκεπτών , ενώ παράλληλα προσελκύουν περισσότερους
        επισκέπτες στο χώρο τους και προβάλλουν την επιχείρηση τους στους χάρτες
        της εφαρμογής. Παράλληλα η εταιρία EV Loader υποστηρίζει ξενοδοχεία,
        επιχειρήσεις παρκιγκ, εστιατόρια, καφέ αλλά και ιδιώτες να εγκαταστήσουν
        σταθμό φόρτισης στο χώρο τους. Η εταιρία παρέχει διαφορετικά μοντέλα
        φορτιστών και υπηρεσίες εγκατάστασης από αδειούχους ηλεκτρολόγους σε όλη
        την Ελλάδα.
      </Typography>
    </div>
  );
}

export default AboutContainer;
